import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ReportsService } from "../reports.service";
import { FormBuilder } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SportService } from "src/app/sports/sport.service";

@Component({
    selector: "app-summary-fixture-list-detail",
    templateUrl: "./summary-fixture-list-detail.component.html",
    styleUrls: ["./summary-fixture-list-detail.component.scss"],
})
export class SummaryFixtureListDetailComponent implements OnInit {
    public fixture: any = null;
    public isAthletics = false;
    public isRunning = false;
    public isChess = false;
    public isOrdered = false;
    public isMiniMarathon = false;
    public sport: any = null;
    public menAthletes: any = [];
    public womenAthletes: any = [];

    constructor(
        private activetedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private reportService: ReportsService,
        private sportService: SportService
    ) {
        this.spinner.show();
        document.querySelector("body").classList.add("public-content");
        this.activetedRoute.params.subscribe((params) => {
            if (params === null || params === undefined) {
                setTimeout(() => {
                    this.spinner.hide();
                }, 500);

                return false;
            }

            this.getFixture(params.id);
        });
    }

    ngOnInit() {}

    getFixture(id: number) {
        this.reportService.getFixtureById(id).subscribe((res) => {
            this.fixture = res.result;

            if (res.result.sport_id === 1) {
                this.isAthletics = true;
                this.isRunning = false;
            }

            if (
                res.result.category_id <= 30 ||
                (res.result.category_id >= 38 &&
                    res.result.category_id <= 64) ||
                (res.result.category_id >= 247 &&
                    res.result.category_id <= 258) ||
                res.result.sport_id === 13
            ) {
                this.isAthletics = false;
                this.isRunning = true;
            }

            if (res.result.sport_id === 11 || res.result.sport_id === 12) {
                this.isAthletics = false;
                this.isRunning = false;
                this.isChess = true;
            }

            if (
                res.result.category_id >= 266 &&
                res.result.category_id <= 273
            ) {
                this.isAthletics = false;
                this.isRunning = false;
                this.isChess = false;
                this.isOrdered = true;
            }

            if (res.result.category_id === 275) {
                this.menAthletes = res.result.men;
                this.womenAthletes = res.result.women;

                this.isMiniMarathon = true;
                this.isAthletics = false;
                this.isRunning = false;
                this.isChess = false;
                this.isOrdered = false;
            }

            this.sportService
                .getSportById(res.result.sport_id)
                .subscribe((sport) => {
                    this.sport = sport;
                    setTimeout(() => {
                        this.spinner.hide();
                    }, 500);
                });
        });
    }
}
